var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-container relative w-full h-0 pt-0",staticStyle:{"padding-bottom":"60%"}},[_c('iframe',{attrs:{"src":_vm.urlComplete,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }